<script>
import { store } from './store.js'
import PaintItem from './PaintItem.vue'

export default {
  components: {
    PaintItem,
  },
  data() {
    return {
      store
    }
  },

  created(){
  
  },
  mounted(){
   
  },
  updated() {
    window.opengraphmakeshot();
  },
  methods: {
  },
};
</script>

<template>

    <!--<div id="wrapper" class="opengraphiqitem" style="visibility:hidden;">-->
     <!--<div id="wrapper-inner" class="opengraphiqitem" style="visibility:hidden; width:1200px; height:630px">-->

 <div id="wrapper" class="opengraphiqitem og-wrapper" style="">
 <div id="wrapper-inner" class="opengraphiqitem og-wrapper-inner" style="width:1200px; height:630px">
  
      <PaintItem v-for="(item, index) in store.domelements" :item="item" :index="index" :key="item.id" />
  
    </div>
  </div>  

</template>